var React = require('react');

function GotoInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 9H21","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M13 1L21.5 9L13 17","strokeWidth":"2","key":1})]);
}

GotoInline.defaultProps = {"width":"23","height":"18","viewBox":"0 0 23 18","fill":"none"};

module.exports = GotoInline;

GotoInline.default = GotoInline;
